import { Link } from 'react-router-dom';

export function LogoMark({ className = '', size = 44 }) {
  return (
    <svg
      aria-hidden="true"
      className={className}
      viewBox="0 0 128 128"
      width={size}
      height={size}
      role="img"
    >
      <defs>
        <linearGradient id="vv-envelope" x1="0%" x2="100%" y1="0%" y2="100%">
          <stop offset="0%" stopColor="#FFFDFC" />
          <stop offset="55%" stopColor="#F1E4EE" />
          <stop offset="100%" stopColor="#D8C5D6" />
        </linearGradient>
        <linearGradient id="vv-ring" x1="0%" x2="100%" y1="0%" y2="100%">
          <stop offset="0%" stopColor="#FFF6BE" />
          <stop offset="32%" stopColor="#F0BC4A" />
          <stop offset="68%" stopColor="#C97A12" />
          <stop offset="100%" stopColor="#FFE07C" />
        </linearGradient>
        <linearGradient id="vv-diamond" x1="0%" x2="100%" y1="0%" y2="100%">
          <stop offset="0%" stopColor="#FFFFFF" />
          <stop offset="52%" stopColor="#DDE4FF" />
          <stop offset="100%" stopColor="#A8B5E8" />
        </linearGradient>
        <linearGradient id="vv-heart" x1="0%" x2="0%" y1="0%" y2="100%">
          <stop offset="0%" stopColor="#FFB4D1" />
          <stop offset="100%" stopColor="#E55A9A" />
        </linearGradient>
        <filter id="vv-shadow" x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="0" dy="8" stdDeviation="6" floodColor="#8F667D" floodOpacity="0.22" />
        </filter>
      </defs>

      <g filter="url(#vv-shadow)">
        <path
          d="M24 66c0-4.4 3.6-8 8-8h62c4.4 0 8 3.6 8 8v30c0 4.4-3.6 8-8 8H32c-4.4 0-8-3.6-8-8z"
          fill="url(#vv-envelope)"
          stroke="#D7C2D3"
          strokeWidth="1.5"
          transform="rotate(-8 64 82)"
        />
        <path
          d="M28 63l35 24 38-28"
          fill="none"
          stroke="#C4AFC2"
          strokeWidth="1.8"
          strokeLinecap="round"
          transform="rotate(-8 64 82)"
        />
        <path
          d="M27 95l24-19M101 98L75 75"
          fill="none"
          stroke="#D8C8D7"
          strokeWidth="1.5"
          strokeLinecap="round"
          transform="rotate(-8 64 82)"
        />
      </g>

      <circle cx="64" cy="66" r="28" fill="none" stroke="url(#vv-ring)" strokeWidth="10" />
      <circle cx="64" cy="66" r="20" fill="#FFF8FB" stroke="#B87018" strokeOpacity="0.35" strokeWidth="1.5" />

      <path
        d="M64 14l6 8-6 8-6-8zm-10 8h20l-10 16z"
        fill="url(#vv-diamond)"
        stroke="#9EABD8"
        strokeWidth="1.4"
      />
      <path d="M54 22l10 8 10-8M58 22l6 8 6-8" fill="none" stroke="#F8FBFF" strokeWidth="1.2" />

      <path
        d="M64 79c-10-6.5-15-11.6-15-18.2 0-5.7 4.2-9.8 9.5-9.8 2.6 0 4.7 1.1 5.5 3 0.8-1.9 2.9-3 5.5-3 5.3 0 9.5 4.1 9.5 9.8 0 6.6-5 11.7-15 18.2z"
        fill="url(#vv-heart)"
        stroke="#D94B86"
        strokeWidth="1.6"
      />

      <g fill="#FFF7EA">
        <path d="M24 42l2.4 5.6L32 50l-5.6 2.4L24 58l-2.4-5.6L16 50l5.6-2.4z" />
        <path d="M102 32l1.7 4 4 1.7-4 1.7-1.7 4-1.7-4-4-1.7 4-1.7z" />
        <path d="M17 73l1.4 3.3 3.3 1.4-3.3 1.4L17 83l-1.4-3.3-3.3-1.4 3.3-1.4z" />
        <path d="M91 95l1.9 4.5 4.5 1.9-4.5 1.9-1.9 4.5-1.9-4.5-4.5-1.9 4.5-1.9z" />
      </g>
    </svg>
  );
}

export function BrandLogo({
  className = '',
  iconClassName = '',
  titleClassName = '',
  subtitleClassName = '',
  subtitle = 'Invitation studio',
  iconSize = 44,
  linked = false,
}) {
  const content = (
    <>
      <div className="flex h-11 w-11 items-center justify-center rounded-[22px] bg-[radial-gradient(circle_at_top,#fffdf4_0%,#f4e1b0_42%,#f8f2e8_100%)] shadow-[0_12px_34px_rgba(212,175,55,0.2)]">
        <LogoMark className={iconClassName} size={iconSize} />
      </div>
      <div className="leading-none">
        <div className={`font-serif tracking-[-0.03em] text-[#1F1A17] ${titleClassName}`.trim()}>
          VowVisionsAI
        </div>
        <div className={`mt-1 uppercase tracking-[0.22em] text-[#8B8379] ${subtitleClassName}`.trim()}>
          {subtitle}
        </div>
      </div>
    </>
  );

  if (linked) {
    return (
      <Link to="/" className={`flex items-center gap-3 text-[#1F1A17] ${className}`.trim()}>
        {content}
      </Link>
    );
  }

  return <div className={`flex items-center gap-3 text-[#1F1A17] ${className}`.trim()}>{content}</div>;
}
